/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPWITHHOLDINGTAXTYPE } from './IAPWITHHOLDINGTAXTYPE';
import {
    IAPWITHHOLDINGTAXTYPEFromJSON,
    IAPWITHHOLDINGTAXTYPEFromJSONTyped,
    IAPWITHHOLDINGTAXTYPEToJSON,
} from './IAPWITHHOLDINGTAXTYPE';

/**
 * 
 * @export
 * @interface WithholdingTaxDeclarationViewModel
 */
export interface WithholdingTaxDeclarationViewModel {
    /**
     * 
     * @type {IAPWITHHOLDINGTAXTYPE}
     * @memberof WithholdingTaxDeclarationViewModel
     */
    type: IAPWITHHOLDINGTAXTYPE;
    /**
     * 
     * @type {string}
     * @memberof WithholdingTaxDeclarationViewModel
     */
    taxDeclaration?: string;
    /**
     * 
     * @type {number}
     * @memberof WithholdingTaxDeclarationViewModel
     */
    taxRatePercentage?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof WithholdingTaxDeclarationViewModel
     */
    reasons: Array<string>;
}

/**
 * Check if a given object implements the WithholdingTaxDeclarationViewModel interface.
 */
export function instanceOfWithholdingTaxDeclarationViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "reasons" in value;

    return isInstance;
}

export function WithholdingTaxDeclarationViewModelFromJSON(json: any): WithholdingTaxDeclarationViewModel {
    return WithholdingTaxDeclarationViewModelFromJSONTyped(json, false);
}

export function WithholdingTaxDeclarationViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): WithholdingTaxDeclarationViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': IAPWITHHOLDINGTAXTYPEFromJSON(json['Type']),
        'taxDeclaration': !exists(json, 'TaxDeclaration') ? undefined : json['TaxDeclaration'],
        'taxRatePercentage': !exists(json, 'TaxRatePercentage') ? undefined : json['TaxRatePercentage'],
        'reasons': json['Reasons'],
    };
}

export function WithholdingTaxDeclarationViewModelToJSON(value?: WithholdingTaxDeclarationViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Type': IAPWITHHOLDINGTAXTYPEToJSON(value.type),
        'TaxDeclaration': value.taxDeclaration,
        'TaxRatePercentage': value.taxRatePercentage,
        'Reasons': value.reasons,
    };
}

